export const colorToNumber = color => {
  if (!color) return 0;
  let c = color.substring(1);
  if (c.length == 3) c = c + c;
  c = '0x' + c;
  let ci = parseInt(c, 16);
  return isNaN(ci) ? 0 : ci;
};
